<div>
    <select (change)="changeClub($event.target.value)" class="form-control">
        @for (club of clubs; track club) {
            <option [value]="club.id" [selected]="selectedClubId == club.id">
                {{ club.name }}
            </option>
        }
    </select>
</div>
